import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { RejectOrderPaymentRequest, SellerOrderDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerOrders } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type RejectSellerOrderPaymentInput = {
  storeSlug: string;
  orderId: string;
} & RejectOrderPaymentRequest;

export function useRejectOrderPaymentMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: RejectSellerOrderPaymentInput) => {
      const { storeSlug, orderId, ...body } = input;
      void storeSlug;
      return apiJsonClient<SellerOrderDetail>(endpoints.seller.orderReviewReject(orderId), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerOrders(queryClient, variables.storeSlug);
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.seller.orderById(variables.storeSlug, variables.orderId),
          exact: true,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.seller.orderProof(variables.storeSlug, variables.orderId),
          exact: true,
        }),
      ]);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
  };
}
